import type { AxiosClient } from './utils/client/axios';
import { ApiLayer } from './utils/api-layer';
import { axiosApp } from './utils/client/axios';

type TotpEnableResponse = {
  provisioning_uri: string;
  action: string;
  type: string;
  action_hash: string;
};

type VerifyParams = {
  action: string;
  code: number;
  email: string;
  action_hash?: string;
};

type ToggleTotpParams = {
  locale: string;
};

class TotpLayer extends ApiLayer<AxiosClient> {
  /**
   * Получение данных для генерации qrcode и включения 2fa у пользователя
   */
  fetchEnableTotp(params: ToggleTotpParams) {
    return this.methods.post<TotpEnableResponse>(
      '/user/2fa/enable',
      params
    );
  }

  fetchVerifyCode(params: VerifyParams) {
    return this.methods.post<TotpEnableResponse>(
      '/user/2fa/verify',
      params
    );
  }

  fetchDisableTotp(params: ToggleTotpParams) {
    return this.methods.post<TotpEnableResponse>(
      '/user/2fa/disable',
      params
    );
  }
}

export const TotpAPI = new TotpLayer(axiosApp);
